import type { FC } from 'react';

import { Badge } from '@/components/ui/badge';
import { cn } from '@/lib/utils';
import deviationTimeFormatter from '@/utils/helpers/deviation-time-formatter';
import getDeviationType from '@/utils/helpers/get-deviation-type';

interface TimeDeviationProps {
  time?: number;
  className?: string;
}

const TimeDeviation: FC<TimeDeviationProps> = ({ time = 0, className }) => {
  const timeInMinutes = Math.round(time / 60);

  if (timeInMinutes === 0) {
    return;
  }

  const deviationType = getDeviationType(time);
  const formattedTime = deviationTimeFormatter(timeInMinutes);

  return (
    <Badge
      className={cn(
        'rounded-full min-w-9 px-2! h-6 text-sm font-semibold border border-white',
        deviationType,
        className
      )}
    >
      {formattedTime}
    </Badge>
  );
};

export default TimeDeviation;
